// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchBarA_searchContainer__2IqI0","searchInput":"SearchBarA_searchInput__2zRGH","searchIcon":"SearchBarA_searchIcon__DLov8"};